module.exports = __webpack_public_path__ + "assets/img/1451587607538_.pic_hd.cdf46135.jpg";